import CTAButton from '@/components/Landing/CTAButton'
import SectionWrapper from '@/components/Landing/SectionWrapper'

const Footer = () => {
  return (
    <SectionWrapper
      className="mt-[-1px] items-center gap-10 px-10 pt-[200px]"
      title={
        <>
          Get started <br /> right now
        </>
      }
      backgroundUrl="https://res.cloudinary.com/dwx3u2p1d/image/upload/q_auto:low/v1744760808/footer_o5c2cy.jpg"
    >
      <CTAButton className="mb-[150px]">Join for free</CTAButton>
      <footer className="flex items-center justify-center gap-10 p-5 text-white">
        <button className="!font-libre-baskerville transition-opacity duration-200 hover:opacity-80">
          Careers
        </button>
        <a
          href="https://pages.sprites.ai/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="!font-libre-baskerville transition-opacity duration-200 hover:opacity-80"
        >
          Privacy Policy
        </a>
        <button className="!font-libre-baskerville transition-opacity duration-200 hover:opacity-80">
          Terms of Service
        </button>
      </footer>
    </SectionWrapper>
  )
}

export default Footer
